export default {
  header: '',
  title: 'Êtes-vous sûr de vouloir annuler la réservation {{tripId}}?',
  btnActions: {
    positive: 'Oui',
    negative: 'Non',
  },
  tripNothingChangedMessage: 'Merci à bientôt',
  tripCancelResultMessage: 'Votre réservation {{tripId}} a été annulée avec succès!',
  errorCancelTripAlert: 'Malheureusement, il est trop tard pour annuler votre réservation',
};
